<div class="title" *ngIf="title">
  <div class="coldx">
    <h4>{{title}}</h4>
  </div>
</div>
<div class="row message-wrapper">
  <div class="col-sm-12" [innerHTML]="mainText"></div>
</div>
<div class="row" *ngIf="!hideButtons">
  <!-- <div class="col-sm-6 hidden-xs"></div> -->
  <div class="col-sm-3 col-xs-6">
    <button (click)="onAction(false)" class="btn btn-secondary btn-block">No</button>
  </div>
  <div class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button (click)="onAction(true)" class="btn btn-primary btn-block">Si</button>
  </div>
</div>
<div class="row" *ngIf="confirmButton">
  <div class="col-sm-10"></div>
  <div class="col-sm-2"><button (click)="onAction(true)" class="btn btn-primary btn-block">Ok</button></div>
</div>
